<div #chartContainer class="w-full h-full relative" style="min-height: 200px;"></div>
<div #tooltip
    class="absolute hidden bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl p-0 pointer-events-none z-50 transition-all duration-200 ease-out"
    style="min-width: 180px;"></div>